import type {
  UserWorkJourneyScheduleDetails,
  UserWorkJourneyScheduleSource,
} from '@src/models/interfaces/userWorkJourneySchedule.interface';
import { UserWorkJourneyScheduleMapper } from '@src/models/mappers/UserWorkJourneyScheduleMapper';
import UserRepository from '@src/repositories/UserRepository';
import safeExecute from '@src/util/safeExecute';

class UserWorkJourneyScheduleService {
  private userRepository: UserRepository;

  constructor() {
    this.userRepository = new UserRepository();
  }

  /**
   * Loads the user's relevant work-journey schedule (times, break, location, journey name)
   * from getGeneralUserInfo. Reusable by Real-Time mark attendance and other screens.
   */
  async getScheduleDetails(
    organizationId: string,
    userId: string,
  ): Promise<UserWorkJourneyScheduleDetails | null> {
    return safeExecute(
      async () => {
        if (!organizationId?.trim() || !userId?.trim()) {
          return null;
        }

        const data = (await this.userRepository.getGeneralUserInfo(
          organizationId,
          userId,
        )) as UserWorkJourneyScheduleSource | null;

        if (!data) {
          return null;
        }

        return UserWorkJourneyScheduleMapper.fromGeneralUserInfo({
          attendanceRecords: data.attendanceRecords,
          workJourneyConfig: data.workJourneyConfig,
        });
      },
      'UserWorkJourneyScheduleService.getScheduleDetails',
      { organizationId, userId },
    );
  }
}

export default UserWorkJourneyScheduleService;
